import { render, staticRenderFns } from "./BlogSectionSimpleItem.vue?vue&type=template&id=1eb11d71&scoped=true"
import script from "./BlogSectionSimpleItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogSectionSimpleItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb11d71",
  null
  
)

export default component.exports